export const GET_FITS_QUERY: string = `
  query GetRearMountedChildBikeSeats(
    $language: String!
    $rackWidth: String
    $rackTubeDiameter: String
    $rackType: String
    $frameType: String
    $ispreview: Boolean!
    $categoryId: String!
  ) {
    getRearMountedChildBikeSeats(
      language: $language
      rackWidth: $rackWidth
      rackTubeDiameter: $rackTubeDiameter
      rackType: $rackType
      frameType: $frameType
      ispreview: $ispreview
      categoryId: $categoryId
    ) {
      rearMountedChildBikeSeatsResponse
    }
  }
`;
